import { useCallback } from 'react'

import type { AssigneeSearchResult } from '@percent/domain/iam'
import { usePermissions } from '@percent/admin-dashboard/common/hooks/usePermissions/usePermissions'

/** The page of an account or group, or undefined when the viewer may not open it. */
export function useAssigneeHref() {
  const { userHasPermissions } = usePermissions()

  return useCallback(
    ({ type, id }: Pick<AssigneeSearchResult, 'type' | 'id'>) => {
      if (type === 'account') {
        return userHasPermissions('accounts:can_view') ? `/accounts/members/${id}` : undefined
      }

      return userHasPermissions('groups:can_view') ? `/accounts/groups/${id}` : undefined
    },
    [userHasPermissions]
  )
}
